/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const gap4Css = css`
  gap: 4px;
`;
